/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Audiences_Section_TitleInputs */

const en_directory_taxonomy_audiences_section_title = /** @type {(inputs: Directory_Taxonomy_Audiences_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who are you finding products for?`)
};

const zh_directory_taxonomy_audiences_section_title = /** @type {(inputs: Directory_Taxonomy_Audiences_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你在为谁寻找产品？`)
};

/**
* | output |
* | --- |
* | "Who are you finding products for?" |
*
* @param {Directory_Taxonomy_Audiences_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_audiences_section_title = /** @type {((inputs?: Directory_Taxonomy_Audiences_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Audiences_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_audiences_section_title(inputs)
	return zh_directory_taxonomy_audiences_section_title(inputs)
});
export { directory_taxonomy_audiences_section_title as "directory.taxonomy.audiences.section_title" }